import { createFileRoute } from "@tanstack/react-router";

import { TeamLeavePage } from "@/components/user/team-leave/TeamLeavePage";
import { requireFeature } from "@/lib/feature-gate";

export const Route = createFileRoute("/user/_layout/team-leave")({
  beforeLoad: () => requireFeature("leave"),
  component: TeamLeavePage,
});
